import { render, staticRenderFns } from "./IndividualBuilding.vue?vue&type=template&id=9675d99c&scoped=true&"
import script from "./IndividualBuilding.vue?vue&type=script&lang=js&"
export * from "./IndividualBuilding.vue?vue&type=script&lang=js&"
import style0 from "./IndividualBuilding.vue?vue&type=style&index=0&id=9675d99c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9675d99c",
  null
  
)

export default component.exports